import { render, staticRenderFns } from "./OrbcommLastUpdated.vue?vue&type=template&id=8dfc69a0&scoped=true"
import script from "./OrbcommLastUpdated.vue?vue&type=script&lang=js"
export * from "./OrbcommLastUpdated.vue?vue&type=script&lang=js"
import style0 from "./OrbcommLastUpdated.vue?vue&type=style&index=0&id=8dfc69a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfc69a0",
  null
  
)

export default component.exports